/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForBillingOntologySync extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForBillingOntologySync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForBillingOntologySync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForBillingOntologySync>): BackgroundJobPayloadForBillingOntologySync {
        let obj = Object.assign(new BackgroundJobPayloadForBillingOntologySync(), model);
        BackgroundJobPayloadForBillingOntologySync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForBillingOntologySync>): BackgroundJobPayloadForBillingOntologySync {
        if (!model) return null;
        return BackgroundJobPayloadForBillingOntologySync.newInstance(<BackgroundJobPayloadForBillingOntologySync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForBillingOntologySync) {
        if (!obj) return;

        models.BackgroundJobPayloadForBillingOntologySync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForBillingOntologySync): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForBillingOntologySync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * CoreStack tenant whose data is being projected (named-graph scope).
     */
    tenant_id: string;

    /**
     * CoreStack master account (GraphDB repo scope).
     */
    master_account_id: string;

    /**
     * Cloud account whose RI / SP data is being projected.
     */
    service_account_id: string;

    /**
     * Which ontology family to project: ri, sp, ri_billing or sp_billing.
     */
    family: models.BillingOntologySyncFamily;

}
